import { InputHTMLAttributes, DetailedHTMLProps } from "react";

interface ICheckBoxLabelHookForm
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  className?: string;
  label?: string;
  preIcon?: any;
  register?: any;
  validation?: any;
  hasPermission?: boolean;
  secondDiv?: string;
  ref?: any;
  onClick?: (e: any) => void;
  required?: boolean;
}
const CheckBoxLabelHookForm: React.FC<ICheckBoxLabelHookForm> = ({
  name = "text-name",
  type = "checkbox",
  className,
  label,
  register,
  validation,
  hasPermission,
  disabled = false,
  onClick,
  required = false,
  ...props
}) => {
  return (
    <div className="py-1 w-full text-xs">
      <div className="grid grid-cols-1 md:grid-cols-2 content-center items-center w-full gap-1">
        {label && (
          <label
            htmlFor={name}
            className="flex space-x-1 justify-start expandedLabel fontExpand"
          >
            {required && <div className="text-red-500 pr-0.5 font-bold">*</div>}
            {label}:
          </label>
        )}

        <input
          type="checkbox"
          name={name}
          className={`${className} w-4 h-4 border-gray-50 cursor-pointer hover:cursor-pointer`}
          {...register(name, validation)}
          disabled={disabled}
          onClick={onClick}
        />
      </div>
    </div>
  );
};
export default CheckBoxLabelHookForm;
